import React from 'react';
import {motion, AnimatePresence} from 'framer-motion';

export default function Modal(preps) {
  const {handleModalInfo, handleModal, props} = preps;
  console.log(props);
  return (
    <motion.div
      layout
      initial={{opacity: 0}}
      animate={{
        opacity: 1,
        transition: {ease: 'easeInOut'},
      }}
      exit={{opacity: 0, transition: {ease: 'easeInOut'}}}
      className={`services__modal ${props != null ? 'active-modal' : ''}`}
    >
      <motion.div
        initial={{scale: 0}}
        animate={{scale: 1, transition: {delay: 0.2, ease: 'easeInOut'}}}
        exit={{scale: 0, transition: {ease: 'easeInOut'}}}
        className='services__modal-content'
      >
        <i
          onClick={() => {
            handleModal(false);
            handleModalInfo(null);
          }}
          className='bx bx-x services__modal-close'
        ></i>
        <h3 className='services__modal-title'>{props.modalTitle}</h3>
        <p className='services__modal-description'>{props.modalSubTitle}</p>
        <ul className='services__modal-list'>
          {props.content.map((c) => {
            return (
              <li key={c} className='services__modal-item'>
                <i className='bx bx-check services__modal-icon'></i>
                <p className='services__modal-info'>{c}</p>
              </li>
            );
          })}
        </ul>
      </motion.div>
    </motion.div>
  );
}
